import { useMutation } from '@tanstack/react-query';
import {
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Space,
  Typography,
} from 'antd';
import CNPlanApis from 'apis/CNPlanApis';
import { EditGrayIcon, EditIcon } from 'assets/svg';
import { Button, ButtonAction, SelectForm } from 'components';
import TableComponent from 'components/Table/TableComponent';
import { useUser } from 'contexts/UserProvider';
import dayjs from 'dayjs';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import Content from 'layouts/Content';
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import formatNumber, { formatCurrency } from 'utils/constants/functions';
import { HocChangePagination } from 'utils/HocChangePagination';

import HOPlanApi from 'apis/HOPlanApis';
import { SaleTeamApi } from 'apis/SaleTeamApi';
import LazySelectForm, {
  ILazySelectData,
  ILazySelectParams,
  initLazySelectData,
} from 'components/Select/LazySelectForm';
import { IFilterTeamSaleCb, IParams } from 'interfaces/TeamSale/TeamSale';
import { toast } from 'react-toastify';
import { toastError } from 'utils/constants/functions';
import { icons } from 'utils/constants/icons';
interface IProps {
  data: any;
  setData: (data: any) => void;
  edit: number;
  setEdit: (data: any) => void;
  onRowChange: (index: number, record: any, type?: any) => void;
  dataTeams: any;
  loading?: boolean;
  dataPlants: any;
  pageInfo?: any;
  page: number;
  page_size: number;
  dataTypeRevenue: any;
}
const { SaveTwoTone, CloseCircleTwoTone, PlusOutlined, ReloadOutlined } = icons;

const { Text } = Typography;

const months = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
];

//=================================
const TableCNPlan = forwardRef((props: IProps, ref: any) => {
  const navigate = useNavigate();
  const { user } = useUser();
  const [dataTeamsale, setDataTeamsale] =
    useState<ILazySelectData>(initLazySelectData);
  const [isChoosePlant, setIsChoosePlant] = useState(
    user?.isAdmin || user?.isHO ? false : true,
  );
  const [isChooseTypeRevenue, setIsChooseTypeRevenue] = useState(false);
  const [isChooseYear, setIsChooseYear] = useState(false);
  const [dataKPICN, setDataKPICN] = useState<any>({});
  const [idCheckExistedRevenueTeamSale, setIdCheckExistedRevenueTeamSale] =
    useState<any>(null);
  const { isPending: getTeamSaleLoading, mutate: getTeamSales } = useMutation({
      mutationFn: (params: IFilterTeamSaleCb) =>
        SaleTeamApi.getAllTeamSaleCb(params),
      onSuccess: (res) => {
        if (res?.data?.getTeamSales) {
          setDataTeamsale({
            options: res?.data?.getTeamSales?.items ?? [],
            totalItems: res?.data?.getTeamSales?.pageInfo?.totalItems ?? 0,
          });
        }
      },
      onError: (error) => {
        console.log(error);
      },
    }),
    { isPending: getHOPlantsLoading, mutate: getHOPlants } = useMutation({
      mutationFn: (params: IParams | any) =>
        HOPlanApi.getRevenueHOPlanList(params),
      onSuccess: (res) => {
        setDataKPICN(res?.data?.getRevenueHo?.items[0] ?? {});
      },
      onError: (error) => {
        console.log(error);
      },
    }),
    { mutateAsync: CheckExistedRevenueTeamSale } = useMutation({
      mutationFn: (params: IParams | any) =>
        CNPlanApis.CheckExistedRevenueTeamSale(params),

      onError: (error) => {
        console.log(error);
      },
    });
  const handleTeamSaleScrollChange = (params: ILazySelectParams) => {
    const teamSaleParams: IFilterTeamSaleCb = {
      ...params,
      plantId: form.getFieldValue('plantId'),
    };
    getTeamSales(teamSaleParams);
  };
  const renderValueTable = (value: any) => value || '-';

  useEffect(() => {
    if (!(user?.isAdmin || user?.isHO)) {
      const params = {
        pageSize: 10,
        plantId: user?.plantCode,
      };
      getTeamSales(params);
    }
  }, []);
  // const { mutateAsync: getRevenuePlanHOYearByPlantId } = useMutation({
  //   mutationFn: (params: any) =>
  //     HOPlanApi.getRevenuePlanHOYearByPlantId(params),
  //   onError: (error) => {
  //     console.log(error);
  //   },
  // });
  // const { mutateAsync: getToTalKPICN } = useMutation({
  //   mutationFn: (params: any) =>
  //     CNPlanApis.getRevenueTeamsaleByPlantIdYear(params),
  //   onError: (error) => {
  //     console.log(error);
  //   },
  // });
  // const { mutateAsync: getAllTotalSaleAmt } = useMutation({
  //   mutationFn: (params: any) =>
  //     axiosGraphQL.post('/graphql', {
  //       query: GET_ALL_TOTAL_SALE_AMT,
  //       variables: TEAMSALE_VARIABLE.getAllTotalSaleAmt(params),
  //     }),
  //   onError: (error) => {
  //     console.log(error);
  //   },
  // });

  const newData = {
    teamSalesId: null,
    ...months.reduce(
      (acc, month) => ({
        ...acc,
        [`${month}Saleamt`]: 0,
      }),
      {},
    ),
    totalYearSaleamt: 0,
    unitMoney: 'triệu VND',
    year: null,
    tcreateUser: { fullName: user?.fullName },
    createId: user?.id,
  };
  const {
    data,
    setData,
    edit,
    setEdit,
    onRowChange,
    dataTeams,
    loading,
    dataPlants,
    page,
    page_size,
    dataTypeRevenue,
  } = props;
  const [form] = Form.useForm();

  const getMonthName = (fieldName: string): string => {
    const months = {
      janSaleamt: 'Tháng 1',
      febSaleamt: 'Tháng 2',
      marSaleamt: 'Tháng 3',
      aprSaleamt: 'Tháng 4',
      maySaleamt: 'Tháng 5',
      junSaleamt: 'Tháng 6',
      julSaleamt: 'Tháng 7',
      augSaleamt: 'Tháng 8',
      sepSaleamt: 'Tháng 9',
      octSaleamt: 'Tháng 10',
      novSaleamt: 'Tháng 11',
      decSaleamt: 'Tháng 12',
    };
    return months[fieldName as keyof typeof months] || fieldName;
  };

  const handleChangeSaleamt = (name: string) => {
    const data = form.getFieldsValue();
    // const keys = Object.keys(data);

    const newValue = data[name];

    const valueFormatted = newValue?.replace(/\./g, '')?.replace(',', '.');

    if (
      valueFormatted !== '' &&
      !/^(-)?$|^-?(?:\d{1,3}(?:\.\d{3})*|\d+|\d*\.\d+)(,\d+)?$/.test(
        valueFormatted,
      )
    ) {
      form.setFields([{ name: name, errors: [''] }]);
      toast.dismiss();

      return toastError(`Giá trị ${getMonthName(name)} chỉ được nhập số`);
    }

    const numericValue = Number(valueFormatted);

    if (!isNaN(numericValue)) {
      form.setFieldsValue({ [name]: formatNumber(numericValue) });
    } else {
      form.setFieldsValue({ [name]: undefined });
    }

    if (newValue === '') {
      form.setFieldsValue({ [name]: '' });
    }

    const totals = Object.entries(data).reduce(
      (acc, [key, value]) => {
        const numericVal =
          typeof value === 'string'
            ? parseFloat(value.replace(/\./g, '').replace(',', '.'))
            : value;

        if (typeof numericVal === 'number' && !isNaN(numericVal)) {
          if (key.includes('Saleamt') && key.length === 10) {
            acc.totalYearSaleamt += numericVal;
          }
        }
        return acc;
      },
      { totalYearSaleamt: 0 },
    );

    // keys.forEach((key) => {
    //   if (key.includes('Saleamt') && key.length === 10) {
    //     console.log(newValue);
    //     total += parseFloat(newValue.replace(/\./g, '').replace(',', '.'));
    //   }
    // });

    form.setFieldsValue({ totalYearSaleamt: totals.totalYearSaleamt });
  };

  // const handleChangePerDensity = (record: any) => {
  //   const perDensity = form.getFieldValue('perDensity');
  //   const yearData = form.getFieldValue('year');
  //   const currentYear = dayjs().year();

  //   if (yearData && currentYear > yearData.year() && edit > 0) {
  //     return;
  //   }

  //   console.log(dataKPICN);

  //   if (dataKPICN && perDensity && Object.keys(dataKPICN).length > 0) {
  //     let updatedValues = {};

  //     const percentageOfTotal = (dataKPICN.totalYearSaleamt * perDensity) / 100;
  //     const valuePerMonth = Math.round(percentageOfTotal / 12);

  //     if (record?.id) {
  //       const currentMonthIndex = new Date().getMonth();
  //       const monthsToUpdate = months.slice(currentMonthIndex);

  //       updatedValues = monthsToUpdate.reduce((acc: any, month) => {
  //         const fieldKey = `${month}Saleamt`;
  //         acc[fieldKey] = valuePerMonth;
  //         return acc;
  //       }, {});
  //     } else {
  //       updatedValues = months.reduce((acc: any, month) => {
  //         const fieldKey = `${month}Saleamt`;
  //         acc[fieldKey] = valuePerMonth;
  //         return acc;
  //       }, {});
  //     }

  //     // Cập nhật tổng năm
  //     const totalYearSaleamt = valuePerMonth * 12;

  //     form.setFieldsValue({
  //       ...updatedValues,
  //       totalYearSaleamt,
  //     });
  //   }
  // };

  const handleChangePerDensity = (record: any) => {
    const currentYear = dayjs().year();
    const fieldsValue = form.getFieldsValue();
    const { perDensity, year } = fieldsValue;

    if (year && currentYear > year.year() && edit > 0) return;
    if (!dataKPICN || !perDensity || !(Object.keys(dataKPICN).length > 0))
      return;

    let monthlyRevenue = {} as any;

    if (record?.id && currentYear === record?.year) {
      const currentMonthIndex = new Date().getMonth();
      const monthsToUpdate = months.slice(currentMonthIndex);

      monthlyRevenue = monthsToUpdate.reduce((acc: any, month) => {
        const fieldKey = `${month}Saleamt`;
        if (dataKPICN[fieldKey]) {
          acc[fieldKey] = Math.round(dataKPICN[fieldKey] * (perDensity / 100));
        }
        return acc;
      }, {});

      const totalYearRevenue = Object.keys(dataKPICN)
        .filter((key) => key.includes('Saleamt') && !key.includes('totalYear'))
        .reduce((total, key) => {
          if (monthsToUpdate.some((month) => key.includes(month))) {
            return total + (monthlyRevenue[key] || 0);
          }
          return total + (fieldsValue[key] || 0);
        }, 0);

      monthlyRevenue.totalYearSaleamt = Math.round(totalYearRevenue);
    } else {
      monthlyRevenue = Object.keys(dataKPICN).reduce((acc, currentVal) => {
        if (currentVal.includes('Saleamt')) {
          const revenue = dataKPICN[currentVal] * (perDensity / 100);
          acc[currentVal] = Math.round(revenue);
        }

        return acc;
      }, {} as any);
    }

    form.setFieldsValue({ ...fieldsValue, ...monthlyRevenue });
  };

  const filterOption = useCallback((inputValue: string, option: any) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase());
  }, []);

  const columns: ColumnsTypeCustom = [
    {
      title: 'STT',
      dataIndex: 'stt',
      className: ' align-top',
      align: 'center',
      width: 50,
      render: (_: any, __: any, index: number) =>
        index + 1 + page_size * (page - 1),
    },
    {
      width: 130,
      title: 'Năm',
      dataIndex: 'year',
      className: 'align-top',
      align: 'center',

      render(value, record, index) {
        const currentYear = dayjs().year();

        return index === edit ? (
          <Form.Item
            name={'year'}
            initialValue={value ? dayjs().year(value) : undefined}
            className="w-full"
          >
            <DatePicker
              picker="year"
              inputReadOnly
              placeholder="Chọn năm"
              value={value ? dayjs().year(value) : null}
              disabledDate={(current) =>
                current && current.year() < currentYear
              }
              disabled={record.id ? true : false}
              onChange={(date, dateString) => {
                handleChangeDate(date);
              }}
            />
          </Form.Item>
        ) : (
          value || '-'
        );
      },
    },
    {
      title: 'Chi nhánh',
      dataIndex: 'plantId',
      className: ' align-top',
      align: 'center',
      width: 100,
      render: (value: any, record: any, index: number) =>
        index == edit ? (
          <Form.Item
            name={'plantId'}
            initialValue={user?.isAdmin || user?.isHO ? value : user?.plantCode}
            className="'w-full"
          >
            <SelectForm
              size="middle"
              disabled={
                record.id || !(user?.isAdmin || user?.isHO) || !isChooseYear
                  ? true
                  : false
              }
              className="w-full !h-[30px]"
              options={dataPlants.map((plant: any) => ({
                label: plant.id,
                value: plant.name,
              }))}
              onChange={handleChangeOptionPlant}
            />
          </Form.Item>
        ) : (
          value || '-'
        ),
    },
    {
      title: 'Mã đội',
      dataIndex: ['tteamSales', 'subId'],
      align: 'left',
      className: 'text-left align-top',
      width: 155,
      render: (value: any, record: any, index: number) => {
        return index === edit ? (
          <Form.Item
            name={'teamSalesId'}
            className="'w-full"
            initialValue={value == null ? undefined : value}
          >
            <LazySelectForm
              value={value}
              data={{
                ...dataTeamsale,
                options: dataTeamsale.options
                  .filter((item: any) => {
                    return item.subId;
                  })
                  .map((item) => ({
                    title: item?.name ?? '',
                    label: item?.subId ?? '',
                    value: item?.id ?? '',
                    key: item?.id ?? '',
                  })),
              }}
              size="middle"
              placeholder="Chọn đội"
              loading={getTeamSaleLoading}
              onSelectScrollChange={handleTeamSaleScrollChange}
              onChange={handleChangeOption}
              disabled={
                record.id ||
                ((user?.isAdmin || user?.isHO) && !isChoosePlant) ||
                (!(user?.isAdmin || user?.isHO) && !isChooseYear)
                  ? true
                  : false
              }
              filterOption={filterOption}
            />
          </Form.Item>
        ) : (
          value || '-'
        );
      },
    },
    {
      title: 'Tên đội',
      dataIndex: 'tteamSale',
      className: 'text-left align-top',
      width: 190,
      render: (value: any, record: any, index: number) =>
        index == edit ? (
          <Form.Item
            name={'tteamSale'}
            initialValue={value}
            className="'w-full"
          >
            <Input
              readOnly
              // disabled={record.id ? true : false}
              disabled
              defaultValue={value}
            />
          </Form.Item>
        ) : (
          value || '-'
        ),
    },

    {
      title: 'Mã Loại doanh thu',
      dataIndex: 'typeRevenue',
      className: 'text-left align-top',
      width: 150,
      render: (value: any, record: any, index: number) => {
        return index === edit ? (
          <Form.Item
            name={'typeRevenue'}
            className="'w-full"
            initialValue={value == null ? undefined : value}
          >
            <SelectForm
              // defaultValue={value == null ? null : value}
              className="w-full !h-[30px]"
              size="middle"
              options={dataTypeRevenue.map((team: any) => ({
                label: team.id,
                value: team.name,
                key: team.id,
              }))}
              disabled={
                record.id ||
                ((user?.isAdmin || user?.isHO) && !isChoosePlant) ||
                (!(user?.isAdmin || user?.isHO) && !isChooseYear)
                  ? true
                  : false
              }
              onChange={handleChangeOptionTypeRevenue}
              filterOption={filterOption}
            />
          </Form.Item>
        ) : (
          value || '-'
        );
      },
    },
    {
      title: 'Loại doanh thu',
      dataIndex: ['ttypeRevenue', 'name'],
      className: 'text-left align-top',
      width: 160,
      render: (value: any, record: any, index: number) =>
        index == edit ? (
          <Form.Item
            name={'typeRevenueName'}
            initialValue={value}
            // rules={[{ required: true, message: 'Nhập tên đội' }]}
            className="'w-full"
          >
            <Input
              readOnly
              // disabled={record.id ? true : false}
              disabled
              defaultValue={value}
            />
          </Form.Item>
        ) : (
          value || '-'
        ),
    },
    {
      title: 'Tổng năm',
      dataIndex: 'totalYearSaleamt',
      width: 135,
      type: 'number',
      currency: 'vi-VN',
      align: 'right',
      className: 'text-right align-top',
      render: (value: number, record: any, index: number) =>
        index == edit ? (
          <Form.Item
            name={'totalYearSaleamt'}
            initialValue={value}
            className="'w-full"
          >
            <InputNumber
              readOnly
              disabled
              className="w-full"
              defaultValue={value}
              formatter={(value) => {
                return value ? formatNumber(value) : '';
              }}
              parser={(value: any) => {
                return parseFloat(value.replace(/\./g, '')?.replace(',', '.'));
              }}
            />
          </Form.Item>
        ) : (
          formatCurrency({
            // value: Math.round(value),
            value: value,
            force: false,
            // format: 3,
          })
        ),
    },
    {
      title: '%',
      align: 'right',
      dataIndex: 'perDensity',
      className: 'text-right align-top',
      width: 90,
      type: 'number',
      render: (value: any, record: any, index: number) => {
        return index === edit ? (
          <Form.Item
            name={'perDensity'}
            className="'w-full"
            initialValue={value == null ? undefined : value}
          >
            <InputNumber<number>
              defaultValue={value}
              className="w-full !h-[30px]"
              precision={2}
              min={0}
              formatter={(value) => `${value}`}
              parser={(value: any) =>
                value?.replace(',', '.') as unknown as number
              }
              disabled={!record.id && !isChooseTypeRevenue ? true : false}
              onChange={() => handleChangePerDensity(record)}
            />
          </Form.Item>
        ) : (
          value || '-'
        );
      },
    },
    ...months
      .map(
        (month: string, index: number) =>
          [
            {
              title: `Tháng ${index + 1}`,
              align: 'right',
              dataIndex: `${month}Saleamt`,
              width: 149,
              type: 'number',
              currency: 'vi-VN',
              className: 'text-right align-top',
              render: (value: any, record: any, index: number) =>
                index == edit ? (
                  <Form.Item
                    name={`${month}Saleamt`}
                    initialValue={value}
                    className="'w-full"
                    rules={[
                      {
                        pattern:
                          /^(-)?$|^-?(?:\d{1,3}(?:\.\d{3})*|\d+|\d*\.\d+)(,\d+)?$/,
                        message: '',
                      },
                    ]}
                  >
                    <Input
                      className="w-full"
                      defaultValue={value}
                      onChange={() => handleChangeSaleamt(`${month}Saleamt`)}
                    />
                  </Form.Item>
                ) : (
                  formatCurrency({
                    // value: Math.round(value),
                    value: value,
                    force: false,
                    // format: 3,
                  })
                ),
            },
          ] as any,
      )
      .flat(),
    {
      title: 'Tiền tệ',
      dataIndex: 'unitMoney',
      align: 'left',
      className: 'align-top',
      width: 100,
      render: (_value: any, _record: any, index: number) =>
        index == edit ? (
          <Form.Item
            name={'unitMoney'}
            initialValue="triệu VND"
            // rules={[{ required: true, message: 'Nhập ' }]}
            className="'w-full"
          >
            <Input disabled readOnly />
          </Form.Item>
        ) : (
          'triệu VND'
        ),
    },
    {
      align: 'left',
      title: 'Người tạo',
      dataIndex: 'tcreateUser',
      className: 'text-left align-top',
      width: 141,
      render(value, record, index) {
        return index == edit ? (
          <Form.Item
            name={'tcreateUser'}
            initialValue={value.fullName}
            className="'w-full"
          >
            <Input disabled readOnly defaultValue={value} />
          </Form.Item>
        ) : (
          value || '-'
        );
      },
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'createDate',
      type: 'date',
      className: 'align-top',
      width: 170,
      render: (value: any) =>
        (value && dayjs(value).format('DD/MM/YYYY HH:mm:ss')) || '-',
    },
    {
      title: 'Người cập nhật',
      dataIndex: 'tmodifyUser',
      className: 'text-left align-top',
      width: 141,
      render(value, record, index) {
        return index == edit && record?.id ? (
          <Form.Item
            name={'tmodifyUser'}
            initialValue={user?.fullName}
            className="'w-full"
          >
            <Input disabled readOnly defaultValue={user?.fullName} />
          </Form.Item>
        ) : (
          value || '-'
        );
      },
    },
    {
      title: 'Ngày cập nhật',
      dataIndex: 'modifyDate',
      className: 'align-top',
      // align: 'center',
      type: 'date',
      width: 170,
      render: (value: any) =>
        (value && dayjs(value).format('DD/MM/YYYY HH:mm:ss')) || '-',
    },
    {
      title: 'Trạng thái',
      dataIndex: 'a',
      className: 'align-top',
      width: 170,
      render: (value: any) => value || '-',
    },
    {
      title: 'Người gửi duyệt',
      dataIndex: 'a',
      className: 'align-top',
      width: 170,
      render(value, record, index) {
        return index == edit ? (
          <Form.Item name={'tcreateUser'} className="'w-full">
            <Input disabled readOnly defaultValue={value} />
          </Form.Item>
        ) : (
          value || '-'
        );
      },
    },
    {
      title: 'Ngày gửi duyệt',
      dataIndex: 'a',
      className: 'align-top',
      // type: 'date',
      width: 170,
      render: (value: any) => value || '-',
    },
    {
      title: 'Người duyệt',
      dataIndex: 'a',
      className: 'align-top',
      // align: 'center',
      width: 170,
      render: (value: any) => value || '-',
    },
    {
      // title: "Thao tác",
      fixed: 'right',
      align: 'center',
      width: 120,
      render: (_: any, record: any, index) =>
        edit == index ? (
          <Space size={'middle'} className="text-lg ">
            <ButtonAction tooltip="Lưu" onClick={() => handleSave(record)}>
              <SaveTwoTone style={{ fontSize: 20 }} />
            </ButtonAction>
            <ButtonAction tooltip="Hủy" onClick={handleCancel}>
              <CloseCircleTwoTone style={{ fontSize: 20 }} />
            </ButtonAction>
          </Space>
        ) : (
          <Space size={'middle'} className="text-lg ">
            {/* <ButtonAction
              tooltip={'Xem chi tiết'}
              onClick={() =>
                navigate(`${path.CN_PLAN_DETAIL}`, { state: record })
              }
            >
              <EyeIcon />
            </ButtonAction> */}
            {/* {true && ( */}
            <ButtonAction
              tooltip={'Chỉnh sửa'}
              onClick={() => {
                // setSaleAmtOld(record.totalYearSaleamt ?? 0);
                setEdit(index);
                form.resetFields();
                getHOPlants({
                  year: record?.year,
                  plantId: record?.plantId,
                  typeRevenue: record?.typeRevenue,
                });
              }}
              disabled={edit !== -1}
            >
              {edit == -1 ? <EditIcon /> : <EditGrayIcon />}
            </ButtonAction>
            {/* )} */}
          </Space>
        ),
    },
  ];

  useImperativeHandle(ref, () => ({
    handleeAddRow,
    handleExportExcel,
    getData,
  }));

  function handleExportExcel() {
    // const { headerRow } = getData();
  }

  const [isAddRow, setIsAddRow] = useState(false);

  function handleeAddRow() {
    if (page == 1) {
      setEdit(0);
      // setSaleAmtOld(0);
      form.resetFields();
      setData((pre: any) => [newData, ...pre]);
      return;
    }
    navigate(`?page=1&page_size=${page_size}`);

    setIsAddRow(true);
  }

  useEffect(() => {
    if (isAddRow) {
      setEdit(0);
      // setSaleAmtOld(0);
      form.resetFields();
      setData((pre: any) => [newData, ...pre]);
      setIsAddRow(false);
    }
  }, [data]);

  const checkFormValidate = async () => {
    try {
      await form.validateFields();
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleSave = async (record: any) => {
    if (!(await checkFormValidate())) {
      return;
    }
    form.setFields(
      form.getFieldsError().map(({ name }) => ({ name, errors: [] })),
    );

    const { teamSalesId, plantId, typeRevenue, typeRevenueName, year } =
      form.getFieldsValue();
    if (!year) {
      form.setFields([{ name: 'year', errors: [''] }]);
      toastError('Chưa chọn năm');
      return;
    } else {
      form.setFields([{ name: 'year', errors: [] }]);
    }
    if (!plantId) {
      form.setFields([{ name: 'plantId', errors: [''] }]);
      toastError('Chưa chọn chi nhánh');
      return;
    }
    if (!teamSalesId) {
      form.setFields([{ name: 'teamSalesId', errors: [''] }]);
      toastError('Chưa chọn đội');
      return;
    } else {
      form.setFields([{ name: 'teamSalesId', errors: [] }]);
    }

    if (!typeRevenue) {
      form.setFields([{ name: 'typeRevenue', errors: [''] }]);
      toastError('Chưa chọn loại doanh thu');
      return;
    } else {
      form.setFields([{ name: 'typeRevenue', errors: [] }]);
    }

    for (const index in months) {
      const month = months[index];
      if (form.getFieldValue(`${month}Saleamt`) === undefined) {
        form.setFields([{ name: `${month}Saleamt`, errors: [''] }]);
        toastError(`Chưa nhập doanh thu tháng ${Number(index) + 1}`);
        return;
      } else {
        form.setFields([{ name: `${month}Saleamt`, errors: [] }]);
      }

      if (
        (typeRevenue == 'DT01' || typeRevenue == 'DT02') &&
        form.getFieldValue(`${month}Saleamt`) < 0
      ) {
        form.setFields([{ name: `${month}Saleamt`, errors: [''] }]);
        toastError(
          `Doanh thu tháng ${Number(index) + 1} không được âm khi chọn loại doanh thu là: ${typeRevenueName}`,
        );
        return;
      }
    }

    const { tteamSale, tmodifyUser, ...fieldsValue } = form.getFieldsValue();
    // Loại bỏ tmodifyUser từ record
    const {
      tcreateUser,
      tmodifyUser: recordTmodifyUser,
      ...recordNew
    } = record;

    const [CheckExisted] = await Promise.all([
      CheckExistedRevenueTeamSale({
        plantId,
        teamSalesId,
        typeRevenue,
        year: parseInt(dayjs(year).format('YYYY')),
      }),
    ]);

    if (CheckExisted?.data?.getRevenueTteamsales?.items.length > 0) {
      setIdCheckExistedRevenueTeamSale(
        CheckExisted?.data?.getRevenueTteamsales?.items[0]?.id,
      );
      setIsOpenModal(true);
      return;
    }

    Object.keys(fieldsValue).forEach((key) => {
      if (key.includes('Saleamt') || key.includes('totalYearSaleamt')) {
        const fieldValue = fieldsValue[key].toString();

        if (parseFloat(fieldValue) < 1)
          fieldsValue[key] = parseFloat(fieldValue);
        else {
          const value = fieldValue.replace(/\./g, '').replace(',', '.');
          const formattedValue = parseFloat(value);

          fieldsValue[key] = fieldValue.includes(',')
            ? Math.round(formattedValue)
            : formattedValue;
        }
      }
    });

    onRowChange(edit, {
      ...recordNew,
      ...fieldsValue,
      ...(record.id && { teamSalesId: data[edit]?.teamSalesId }),
      year: parseInt(dayjs(year).format('YYYY')),
    });
    form.resetFields();
    setEdit(-1);
    setIsChoosePlant(false);
    setIsChooseYear(false);
    setIsChooseTypeRevenue(false);
    setDataKPICN({});
  };

  const handleCancel = () => {
    edit == 0 && !data[0]?.id && setData(data.slice(1));
    form.resetFields();
    setEdit(-1);
    setIsAddRow(false);
    setIsChoosePlant(false);
    setIsChooseYear(false);
    setIsChooseTypeRevenue(false);
    setDataKPICN({});
  };
  const handleChangeOption = (_: any, option: any) => {
    const value = form.getFieldsValue();

    form.setFieldsValue({
      ...value,
      tteamSale: option?.title,
      teamSalesId: option?.value,
    });
  };
  const handleChangeOptionTypeRevenue = (_: any, option: any) => {
    if (_ == undefined) {
      setIsChooseTypeRevenue(false);
      form.setFieldsValue({
        typeRevenueName: undefined,
        perDensity: undefined,
      });
      return;
    }
    setIsChooseTypeRevenue(true);
    form.setFieldsValue({
      perDensity: undefined,
    });
    const value = form.getFieldsValue();
    form.setFieldsValue({
      ...value,
      typeRevenue: option?.label,
      typeRevenueName: option?.value,
    });
    getHOPlants({
      year: dayjs(value.year).year(),
      plantId: value.plantId,
      typeRevenue: option?.label,
    });
  };
  const handleChangeDate = (date: any) => {
    if (date == null) {
      setIsChooseYear(false);
      setIsChoosePlant(false);
      setIsChooseTypeRevenue(false);
      setDataKPICN({});
      if (!(user?.isAdmin || user?.isHO)) {
        form.setFieldsValue({
          teamSalesId: undefined,
          typeRevenue: undefined,
          tteamSale: undefined,
          typeRevenueName: undefined,
          perDensity: undefined,
        });
        return;
      }
      form.setFieldsValue({
        tteamSale: undefined,
        plantId: undefined,
        teamSalesId: undefined,
        typeRevenue: undefined,
        typeRevenueName: undefined,
        perDensity: undefined,
      });
      return;
    }
    const value = form.getFieldsValue();
    if (!(user?.isAdmin || user?.isHO)) {
      form.setFieldsValue({
        ...value,
        year: date,

        typeRevenue: undefined,
        typeRevenueName: undefined,
        perDensity: undefined,
      });
      setIsChooseYear(true);
    } else {
      form.setFieldsValue({
        ...value,
        year: date,
        plantId: undefined,
        tteamSale: undefined,
        teamSalesId: undefined,
        typeRevenue: undefined,
        typeRevenueName: undefined,
        perDensity: undefined,
      });
      setIsChooseYear(true);
    }
  };
  const handleChangeOptionPlant = (_: any, option: any) => {
    if (_ == undefined) {
      setIsChoosePlant(false);
      setIsChooseTypeRevenue(false);
      setDataKPICN({});

      form.setFieldsValue({
        tteamSale: undefined,
        teamSalesId: undefined,
        perDensity: undefined,
        typeRevenue: undefined,
        typeRevenueName: undefined,
      });
      return;
    }
    const value = form.getFieldsValue();

    form.setFieldsValue({
      ...value,
      plantId: option?.label,
      tteamSale: undefined,
      teamSalesId: undefined,
      typeRevenue: undefined,
      typeRevenueName: undefined,
      perDensity: undefined,
    });
    setIsChoosePlant(true);
    form.setFieldsValue({ tteamSale: undefined, teamSalesId: undefined });
    const params = {
      pageSize: 10,
      ...(value && { plantId: option?.label }),
    };
    getTeamSales(params);
  };
  const getData = () => {
    return { headerRow: columns, datas: data };
  };
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleSaleLineSubmit = () => {
    const { tteamSale, tmodifyUser, ...fieldsValue } = form.getFieldsValue();

    Object.keys(fieldsValue).forEach((key) => {
      if (key.includes('Saleamt') || key.includes('totalYearSaleamt')) {
        const fieldValue = fieldsValue[key].toString();

        if (parseFloat(fieldValue) < 1)
          fieldsValue[key] = parseFloat(fieldValue);
        else {
          const value = fieldValue.replace(/\./g, '').replace(',', '.');
          const formattedValue = parseFloat(value);

          fieldsValue[key] = fieldValue.includes(',')
            ? Math.round(formattedValue)
            : formattedValue;
        }
      }
    });

    const sumtotalYearSaleamt = months.reduce(
      (acc, month) => acc + fieldsValue[`${month}Saleamt`],
      0,
    );

    onRowChange(
      edit,
      {
        ...fieldsValue,
        totalYearSaleamt: sumtotalYearSaleamt,
        year: parseInt(dayjs(fieldsValue?.year).format('YYYY')),
        id: idCheckExistedRevenueTeamSale,
      },
      'update',
    );
    form.resetFields();
    setEdit(-1);
    setIsChoosePlant(false);
    setIsChooseYear(false);
    setIsChooseTypeRevenue(false);
    setDataKPICN({});
    setIsOpenModal(false);
  };

  const handleSaleLineCancel = () => {
    setIsOpenModal(false);
  };
  return (
    <Content>
      <Form form={form}>
        {/* <ToastContainer /> */}
        <TableComponent
          dataSource={data}
          columns={columns}
          loading={loading}
          pagination={{
            current: props.pageInfo?.currentPage,
            pageSize: props.pageInfo?.itemsPerPage,
            total: props.pageInfo?.totalItems,
            onChange: HocChangePagination(),
            disabled: !edit,
          }}
        />
      </Form>
      <Modal
        classNames={{
          content: '!p-0',
          header:
            '!px-[24px] !pt-[20px] !pb-[8px] !border-sub !border-solid !border-b-[1px]',
          body: '!px-[42px]',
          footer: '!px-[24px] !py-[20px] !bg-rowTable !rounded-b-[8px]',
        }}
        className="!w-max xl:!w-[880px] lg:!w-[623px] md:!w-[367px] sm:!w-[239px] !rounded-[8px] !top-[10%] !translate-y-[50%]"
        open={isOpenModal}
        title="Thông báo"
        onCancel={handleSaleLineCancel}
        footer={
          <Row gutter={[8, 16]} justify={'end'} align={'middle'}>
            <Col>
              <Button
                fill
                title="Hủy"
                customClass="!bg-rowTable !border-transparent !text-neutral-30"
                handleOnclick={handleSaleLineCancel}
              />
            </Col>
            <Col>
              <Button
                fill
                title="Cập nhật"
                iconBefore={<ReloadOutlined />}
                handleOnclick={handleSaleLineSubmit}
              />
            </Col>
          </Row>
        }
      >
        <p>
          Phân bổ kế hoạch cho đội bạn đang tạo đã được khai báo, bạn có muốn
          cập nhật lại không?
        </p>
      </Modal>
    </Content>
  );
});

export default TableCNPlan;
